import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Table from '@tables/table'
import { AddAnnouncementDialog, EditAnnouncementDialog } from '@dialogs'
import Grid from '@material-ui/core/Grid'
import { API } from '@const'
import * as utils from '@utils'

const COMPONENT_GROUP = 'announcement'

class AnnouncementPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'AnnouncementPage')
        }
    }

    actions = []
    columns = [
        {
            field: 'created_at',
            type: 'datetime',
        },
        {
            field: 'title',
        },
        {
            field: 'content_brief',
        },
        {
            field: 'updated_at',
            type: 'datetime',
        },
    ]

    componentDidMount() {
        this.updateTableColumns()
        this.queryData()
    }

    updateTableColumns() {
        if (utils.checkValid(COMPONENT_GROUP + '.active')) {
            this.columns.push({
                field: 'is_active',
                type: 'active',
                apiPath: API.ANNOUNCEMENT_ACTIVE,
            })
        }

        if (utils.checkValid(COMPONENT_GROUP + '.edit')) {
            this.columns.push({
                field: 'edit',
                type: 'edit',
                component: this.editDialog,
            })
        }

        if (utils.checkValid(COMPONENT_GROUP + '.delete')) {
            this.columns.push({
                field: 'delete',
                type: 'delete',
                apiPath: API.ANNOUNCEMENT,
            })
        }

        if (utils.checkValid(COMPONENT_GROUP + '.add')) {
            this.actions.push({
                icon: 'add',
                text: 'add',
                isFreeAction: true,
                onClick: () => {
                    this.addDialog.OpenDialog()
                },
            })
        }
    }

    queryData() {
        this.table.SetLoading(true)

        utils.apiRequest(
            'get',
            API.ANNOUNCEMENT_LIST,
            {},
            (data) => {
                this.table.SetData(data)
            },
            (_err) => {
                this.table.SetData([])
            },
            true
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Table
                        ownerName="AnnouncementPage"
                        columns={this.columns}
                        actions={this.actions}
                        onRef={(ref) => (this.table = ref)}
                        queryDataArgs={{
                            apiPath: API.ANNOUNCEMENT_LIST,
                        }}
                        options={
                            {
                                orderDirection: 'desc'
                            }
                        }
                    />
                    <AddAnnouncementDialog
                        confirmCallback={() => {
                            this.table.queryData()
                        }}
                        onRef={(ref) => (this.addDialog = ref)}
                    />
                    <EditAnnouncementDialog
                        confirmCallback={() => {
                            this.table.queryData()
                        }}
                        onRef={(ref) => (this.editDialog = ref)}
                    />
                </Grid>
            </Grid>
        )
    }
}

const styles = (_theme) => {
    return {}
}

AnnouncementPage.propTypes = {
    classes: PropTypes.object,
}

export default hoc(styles)(AnnouncementPage)
